import { useCallback, useEffect, useState } from 'react';

import { getFlightCampaignDeals } from '~/services/FlightsService';

export function useFlightCampaignDeals(id: string) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const [data, setData] = useState<Array<App.FlightDeal>>([]);

  const fetchData = useCallback(async () => {
    setLoading(true);

    try {
      const { result } = await getFlightCampaignDeals(id);
      setData(result.rows);
    } catch (error) {
      setError(error);
    }

    setLoading(false);
  }, [id, setData, setLoading, setError]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { loading, error, data, revalidate: fetchData };
}
